import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class CareerApi {
  saveCareer = async (data) => {
    try {
      const response = await api.post("/career", data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed To Save Career Opening. Please Try Again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  getCareers = async (search = "") => {
    try {
      const response = await api.get("/career", {
        params: { search: search },
      });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed To Fetch Career Openings. Please Try Again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return {
        status: false,
        response: error?.response?.data || error,
      };
    }
  };

  updateCareer = async (id, data) => {
    try {
      const response = await api.put(`/career/${id}`, data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed To Update Career Opening. Please Try Again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  deleteCareer = async (id) => {
    try {
      const response = await api.delete(`/career/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed To Delete Career Opening. Please Try Again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  getCareerEnquiries = async (careerId) => {
    try {
      const response = await api.get("/career/enquiries", {
        params: { careerId: careerId },
      });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed To Fetch Career Enquiries. Please Try Again.";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };
}

const careerApi = new CareerApi();
export default careerApi;

export const {
  saveCareer,
  getCareers,
  updateCareer,
  deleteCareer,
  getCareerEnquiries
} = careerApi;
